module.exports = __webpack_public_path__ + "static/media/allcall_textto911.c002f204.svg";